<template>
<div class="blank-layer aligner">

</div>
</template>
<script>
export default {
  name: 'blank'
}
</script>
<style>
.blank-layer {
  width: 100%;
  height: 100%;
  background-color:transparent;
  opacity: 1;
}
</style>
